export default {
      id: "social-small-xing-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#social-small-xing",
      toString: function () {
        return this.url;
      }
    }